import { DigitalResourcesTypeEnum } from 'modules/digital-product/enums/digital-resources-type-enum'
import { DigitalResourceEditType } from 'modules/digital-product/resources/types/digital-resource-edit-interface'

/**
 * A resource can be added to a product once its required fields are filled.
 */
export const isResourceReady = (resource: DigitalResourceEditType): boolean => {
  switch (resource.type) {
    case DigitalResourcesTypeEnum.membership_course:
      return !!resource.course && !!resource.enrollmentAccessType
    case DigitalResourcesTypeEnum.membership_course_bundle:
      return !!resource.courseBundle && !!resource.enrollmentAccessType
    case DigitalResourcesTypeEnum.downloadable_file:
      return !!resource.dataFile
    case undefined:
      return false
    default:
      return !!resource.value
  }
}
